import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { formatDateForGraphQL, formattedDate } from 'shared/utils/date';
import { Grid, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import 'date-fns';
import TextField from '@mui/material/TextField';
import {
  LocalizationProvider,
  DatePicker as KeyboardDatePickerMui,
} from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import SaveIcon from '@mui/icons-material/Save';
import CalendarSvg from 'shared/statics/svg/Calendar.svg';

const useStyles = makeStyles(() => ({
  button: {
    marginTop: 5,
    marginBottom: 10,
    height: '48px',
  },
}));

const TODAY = moment();

const DueDate = ({ year, number, onChangeTimelineDate, onSave }) => {
  const [selectedDate, setSelectedDate] = React.useState(
    formattedDate(year?.[`report_date_${number}`] || new Date()),
  );
  const classes = useStyles();

  const handleDateChange = date => {
    setSelectedDate(date);
  };

  const handleSave = () => {
    if (
      !selectedDate ||
      selectedDate === 'Invalid date' ||
      formattedDate(selectedDate) < TODAY
    ) {
      return;
    }
    onChangeTimelineDate(formatDateForGraphQL(selectedDate));
    onSave();
  };

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs={12}>
            <KeyboardDatePicker
              disablePast
              inputFormat="dd MMM yyyy"
              value={formattedDate(selectedDate)}
              onChange={handleDateChange}
              renderInput={params => (
                <TextField
                  {...params}
                  id="date-picker-inline"
                  margin="normal"
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              className={classes.button}
              startIcon={<SaveIcon />}
              onClick={handleSave}
              disabled={!selectedDate}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </LocalizationProvider>
    </>
  );
};

const KeyboardDatePicker = styled(KeyboardDatePickerMui)`
  align-items: center;
  .MuiIconButton-label {
    &:before {
      content: '';
      width: 25px;
      height: 25px;
      background-size: cover;
      background-image: url(${CalendarSvg});
    }
    .MuiSvgIcon-root {
      display: none;
    }
  }
`;

export default DueDate;
